<template>
  <el-row :gutter="24" type="flex" justify="end" class="cc-search-filters">
    <el-col :xs="12" :sm="8" :lg="5">
      <admin-select :id="searchData.user_id" @change="onChange" />
    </el-col>
    <el-col :xs="12" :sm="8" :lg="3">
      <el-select v-model="searchData.status" placeholder="Статус задачи">
        <el-option
          v-for="(status, i) in taskStatuses"
          :key="i"
          :label="status"
          :value="i"
        />
      </el-select>
    </el-col>
    <el-col :xs="12" :sm="8" :lg="6">
      <el-date-picker
        v-model="searchData.date"
        type="daterange"
        start-placeholder="Искать с"
        end-placeholder="Искать до"
        value-format="yyyy-MM-dd"
        format="dd.MM.yyyy"
        :picker-options="pickerOptions"
      />
    </el-col>
    <el-col :xs="12" :sm="8" :lg="4">
      <el-button type="primary" @click="onSearch">Поиск</el-button>
    </el-col>
    <el-col :xs="12" :sm="8" :lg="4">
      <el-button type="primary" plain @click="onClear">
        Сбросить фильтры
      </el-button>
    </el-col>
    <el-col :xs="12" :sm="8" :lg="2" class="ta-r dop">
      <additional-menu :tasks="true" @add="setModal(true)" />
    </el-col>
    <add-task-modal :visible="visible" @close="setModal" v-on="$listeners" />
  </el-row>
</template>

<script>
import { pickerRangeOpt } from '@/datas/consts'
import { taskStatuses } from '@/views/CallCenter/constants'
import AddTaskModal from './Modals/AddTaskModal'
import AdditionalMenu from './AdditionalMenu'
import AdminSelect from './AdminSelect'

export default {
  name: 'SearchFilters',
  components: { AdditionalMenu, AddTaskModal, AdminSelect },
  data() {
    return {
      taskStatuses,
      pickerOptions: pickerRangeOpt,
      visible: false,
      searchData: {
        user_id: null,
        status: null,
        date: null,
      },
    }
  },
  methods: {
    onSearch() {
      const { user_id, status, date } = this.searchData
      const date_from = date ? date[0] : null
      const date_to = date ? date[1] : null
      const search = { user_id, status, date_from, date_to }

      this.$emit('search', search)
    },
    setModal(flag = false) {
      this.visible = flag
    },
    onChange(val) {
      this.searchData.user_id = val
    },
    onClear() {
      this.searchData = {
        user_id: null,
        status: null,
        date: null,
      }
      this.$emit('search')
    },
  },
}
</script>

<style lang="sass">
.cc-search-filters
  flex-wrap: wrap
  margin-bottom: 40px
  .el-col
    margin-bottom: 20px
    .el-date-editor.el-input
      width: 100%
    input:not(.el-range-input),
      height: 52px
    button, .el-input__inner
      height: 52px
      width: 100%
    .el-date-editor .el-range-separator
      line-height: 46px
    &.dop>button
      width: auto
    &.flights-count
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #00BF4E;
      justify-content: center
      .el-loading-spinner
        margin-top: -10px
</style>
